import { render } from "./MessagesOutbox.vue?vue&type=template&id=7bd28b74&scoped=true"
import script from "./MessagesOutbox.vue?vue&type=script&lang=js"
export * from "./MessagesOutbox.vue?vue&type=script&lang=js"

import "./MessagesOutbox.vue?vue&type=style&index=0&id=7bd28b74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd28b74"]])

export default __exports__